// extracted by mini-css-extract-plugin
export default {"Nav":"Nav_Nav__W82tM","swing-in":"Nav_swing-in__IOc08"};